import { EventVenueType } from '@core/enums/event/event-venue-type.enum';
import { OnlineEventType } from '@core/enums/event/online-event-type.enum';
import { TicketTemplateBoxofficeType } from '@core/enums/ticket-template-boxoffice-type.enum';
import { IChannelSettings } from '@core/interfaces/event/event-channel-settings.interface';
import { IDefaultChannelSettings } from '@core/interfaces/event/event-default-channel-settings.interface';
import { IEventListItem } from '@core/interfaces/event/event-list-item.interface';
import { IEventViewBase } from '@core/interfaces/event/event-view-base.interface';
import { IEventView } from '@core/interfaces/event/event-view.interface';
import { IListResult } from '@core/interfaces/list-result/list-result.interface';
import { AUDITORIUM_VIEW } from '../auditorium/auditorium.mock';
import { PRICE_CATEGORY_LIST } from './price-category.mock';
import { TICKET_FORMATS } from './ticket-formats.mock';

export const EVENT_DEFAULT_CHANNEL_SETTINGS: IDefaultChannelSettings = {
  visibleFrom: '2020-02-10T00:00:00Z',
  visibleTo: '2020-12-16T23:29:59Z',
  availableFrom: '2020-04-16T00:00:00Z',
  availableTo: '2020-12-18T23:16:59Z',
};

export const EVENT_CHANNEL_SETTINGS: IChannelSettings[] = [
  {
    visibleFrom: '2020-11-10T00:00:00Z',
    visibleTo: '2020-11-16T23:29:59Z',
    availableFrom: '2020-11-16T00:00:00Z',
    availableTo: '2020-11-18T23:16:59Z',
    channelId: 'channel-mock1',
  },
  {
    ...EVENT_DEFAULT_CHANNEL_SETTINGS,
    channelId: 'channel-mock2',
  },
];

export const EVENT_VIEW: IEventView = {
  id: 'event-id-1',
  programId: '53a93f49-330c-42a6-be61-907b44e41bba',
  ownerPartnerId: 'b8c88b0e-13a6-4ba8-9668-b6815ddcd594',
  name: 'LiveStream + Video on Demand test event',
  shortDescription: 'Test Event description',
  longDescription: '<p>Lorem ipsum dolor sit amet consectetur adipisicing elit.Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>',
  isFree: false,
  isFreeEntry: false,
  useProgramData: false,
  maxCapacity: 100,
  availableCapacity: 10,
  soldTicketsCount: 0,
  categories: [
    '5d2dd511-b8ef-4726-9dfa-a74b315adc5c',
    'b68e4908-fef6-428a-bf80-2b6fb876d4c0',
    '4f4ddd23-c793-454c-84c1-24e4de330909',
    'fa6ac51e-d768-4f5d-8de7-e17187feeb06',
  ],
  auditorium: AUDITORIUM_VIEW,
  taxId: '353decf9-8d44-468b-ae09-60edfc636543',
  ticketFormats: TICKET_FORMATS,
  defaultBoxOfficeTicketFormatType: TicketTemplateBoxofficeType.SHEET,
  priceCategories: PRICE_CATEGORY_LIST,
  startDate: '2020-11-27T12:59:59Z',
  endDate: '2021-11-27T13:59:59Z',
  livestreamEndDate: '2021-11-27T13:59:59Z',
  previewImageId: '9f70495e-aa5e-4b87-92eb-ee32a42aa5f5',
  gallery: [
    '9f70495e-aa5e-4b87-92eb-ee32a42aa5f5',
    'g917r437-c971-4a8c-879d-fba5ac18dd8',
    'p267r437-c971-4a8c-879d-fba5ac18ck3',
  ],
  isDeleted: false,
  comment: 'Magna nostrud ipsum',
  defaultChannelSettings: EVENT_DEFAULT_CHANNEL_SETTINGS,
  channelSettings: EVENT_CHANNEL_SETTINGS,
  admissionFrom: '2020-10-17T20:59:59Z',
  admissionTo: '2020-10-17T23:59:59Z',
  availableFrom: '2020-01-01T12:02:21+00:00',
  availableTo: '2022-09-09T11:34:30+00:00',
  isPrivate: false,
  isActive: true,
  playbackId: 'f3d425d5-c4e6-40a8-b177-5a18a026a6c5',
  type: EventVenueType.ONLINE,
  onlineEventType: OnlineEventType.LIVESTREAM_VIDEO,
  duration: 140,
  customersCountryIsEnabled: true,
};

export const EVENT_LIST: IListResult<IEventListItem> = {
  resultsLength: 9,
  results: [
    {
      auditoriumName: 'Kulturhuset Brøndenwddw1',
      venueName: 'Kulturhuset',
      previewImageId: '9f70495e-aa5e-4b87-92eb-ee32a42aa5f5',
      id: 'event-id-1',
      name: 'LiveStream + Video on Demand test event',
      startDate: '2020-11-27T12:59:59Z',
      endDate: '2020-11-27T13:59:59Z',
      livestreamEndDate: '2020-11-27T13:59:59Z',
      maxCapacity: 100,
      availableCapacity: 10,
      availableFrom: '2019-10-17T20:59:59Z',
      availableTo: '2022-10-17T23:59:59Z',
      soldTicketsCount: 0,
      comment: 'nincs',
      isFreeEntry: false,
      isFree: false,
      ticketFormats: TICKET_FORMATS,
      priceCategories: PRICE_CATEGORY_LIST,
      shortDescription: 'Az Alapítvány-sorozat Isaac Asimov eredetileg trilógiának induló sci-fi műve, amely végül hét regényből álló sorozattá bővült. A robot scifi zsáner alapítója.',
      type: EventVenueType.ONLINE,
      onlineEventType: OnlineEventType.LIVESTREAM_VIDEO,
      customersCountryIsEnabled: true,
    },
    {
      auditoriumName: 'Kulturhuset Brøndenwddw2',
      venueName: 'Kulturhuset',
      previewImageId: '9f70495e-aa5e-4b87-92eb-ee32a42aa5f5',
      id: 'event-id-12',
      name: 'Very long title Pop-up udstilling om Brøndby Strands højhuse',
      startDate: '2020-01-17T20:59:59Z',
      endDate: '2022-10-17T20:59:59Z',
      livestreamEndDate: '2020-01-17T20:59:59Z',
      maxCapacity: 100,
      availableCapacity: 0,
      availableFrom: '2019-10-17T20:59:59Z',
      availableTo: '2022-10-17T23:59:59Z',
      soldTicketsCount: 0,
      comment: 'nincs',
      isFreeEntry: true,
      isFree: false,
      ticketFormats: TICKET_FORMATS,
      priceCategories: PRICE_CATEGORY_LIST,
      shortDescription: 'Az Alapítvány-sorozat Isaac Asimov eredetileg trilógiának induló sci-fi műve, amely végül hét regényből álló sorozattá bővült. A robot scifi zsáner alapítója.',
      type: EventVenueType.ONLINE,
      onlineEventType: OnlineEventType.LIVESTREAM,
      customersCountryIsEnabled: true,
    },
    {
      auditoriumName: 'Kulturhuset Brøndenwddw3',
      venueName: 'Kulturhuset',
      previewImageId: '9f70495e-aa5e-4b87-92eb-ee32a42aa5f5',
      id: 'event-id-13',
      name: 'Just Right Event Title when just riiiiight',
      startDate: '2020-01-17T20:59:59Z',
      endDate: '2022-10-17T20:59:59Z',
      livestreamEndDate: '2020-01-17T20:59:59Z',
      maxCapacity: 100,
      availableCapacity: 10,
      availableFrom: '2019-10-17T20:59:59Z',
      availableTo: '2022-01-17T23:59:59Z',
      soldTicketsCount: 0,
      comment: 'nincs',
      isFreeEntry: false,
      isFree: false,
      ticketFormats: TICKET_FORMATS,
      priceCategories: PRICE_CATEGORY_LIST,
      shortDescription: 'Az Alapítvány-sorozat Isaac Asimov eredetileg trilógiának induló sci-fi műve, amely végül hét regényből álló sorozattá bővült. A robot scifi zsáner.',
      type: EventVenueType.NORMAL,
      onlineEventType: null,
      customersCountryIsEnabled: false,
    },
    {
      auditoriumName: 'Kulturhuset Brøndenwddw4',
      venueName: 'Kulturhuset',
      previewImageId: '9f70495e-aa5e-4b87-92eb-ee32a42aa5f5',
      id: 'event-id-14',
      name: 'One Liner Event Title',
      startDate: '2020-01-17T20:59:59Z',
      endDate: '2022-10-17T20:59:59Z',
      livestreamEndDate: '2020-01-17T20:59:59Z',
      maxCapacity: 100,
      availableCapacity: 10,
      availableFrom: '2019-10-17T20:59:59Z',
      availableTo: '2022-10-17T23:59:59Z',
      soldTicketsCount: 0,
      comment: 'nincs',
      isFreeEntry: false,
      isFree: false,
      ticketFormats: TICKET_FORMATS,
      priceCategories: PRICE_CATEGORY_LIST,
      shortDescription: 'Literally short description',
      type: EventVenueType.ONLINE,
      onlineEventType: OnlineEventType.VIDEO,
      customersCountryIsEnabled: true,
    },
    {
      auditoriumName: 'Kulturhuset Brøndenwddw5',
      venueName: 'Kulturhuset',
      previewImageId: '9f70495e-aa5e-4b87-92eb-ee32a42aa5f5',
      id: 'event-id-15',
      name: 'Very long title Pop-up udstilling om Brøndby Strands højhuse',
      startDate: '2020-01-17T20:59:59Z',
      endDate: '2022-10-17T20:59:59Z',
      livestreamEndDate: '2020-01-17T20:59:59Z',
      maxCapacity: 100,
      availableCapacity: 0,
      availableFrom: '2019-10-17T20:59:59Z',
      availableTo: '2022-10-17T23:59:59Z',
      soldTicketsCount: 0,
      comment: 'nincs',
      isFreeEntry: false,
      isFree: false,
      ticketFormats: TICKET_FORMATS,
      priceCategories: PRICE_CATEGORY_LIST,
      shortDescription: 'Literally short description',
      type: EventVenueType.NORMAL,
      onlineEventType: null,
      customersCountryIsEnabled: true,
    },
    {
      auditoriumName: 'Kulturhuset Brøndenwddw6',
      venueName: 'Kulturhuset',
      previewImageId: null,
      id: 'event-id-16',
      name: 'Just Right Event Title when just riiiiight',
      startDate: '2020-01-17T20:59:59Z',
      endDate: '2022-10-17T20:59:59Z',
      livestreamEndDate: '2020-01-17T20:59:59Z',
      maxCapacity: 100,
      availableCapacity: null,
      availableFrom: '2019-10-17T20:59:59Z',
      availableTo: '2022-10-17T23:59:59Z',
      soldTicketsCount: 0,
      comment: 'nincs',
      isFreeEntry: false,
      isFree: true,
      ticketFormats: TICKET_FORMATS,
      priceCategories: PRICE_CATEGORY_LIST,
      shortDescription: 'Az Alapítvány-sorozat Isaac Asimov eredetileg trilógiának induló sci-fi műve, amely végül hét regényből álló sorozattá bővült.',
      type: EventVenueType.NORMAL,
      onlineEventType: null,
      customersCountryIsEnabled: true,
    },
    {
      auditoriumName: 'Kulturhuset Brøndenwddw7',
      venueName: 'Kulturhuset',
      previewImageId: '9f70495e-aa5e-4b87-92eb-ee32a42aa5f5',
      id: 'event-id-17',
      name: 'Historier i Højhuset Pop-up udstilling om Brøndby Strands højhuse',
      startDate: '2020-01-17T20:59:59Z',
      endDate: '2020-09-17T20:59:59Z',
      livestreamEndDate: '2020-01-17T20:59:59Z',
      maxCapacity: 100,
      availableCapacity: 0,
      availableFrom: '2019-10-17T20:59:59Z',
      availableTo: '2022-10-17T23:59:59Z',
      soldTicketsCount: 0,
      comment: 'nincs',
      isFreeEntry: true,
      isFree: false,
      ticketFormats: TICKET_FORMATS,
      priceCategories: PRICE_CATEGORY_LIST,
      shortDescription: 'Az Alapítvány-sorozat Isaac Asimov eredetileg trilógiának induló sci-fi műve, amely végül hét regényből álló sorozattá bővült.',
      type: EventVenueType.ONLINE,
      onlineEventType: OnlineEventType.LIVESTREAM,
      customersCountryIsEnabled: true,
    },
    {
      auditoriumName: 'Kulturhuset Brøndenwddw8',
      venueName: 'Kulturhuset',
      previewImageId: '9f70495e-aa5e-4b87-92eb-ee32a42aa5f5',
      id: 'event-id-18',
      name: 'Historier i Højhuset Pop-up udstilling om Brøndby Strands højhuse',
      startDate: '2020-01-17T20:59:59Z',
      endDate: '2020-09-17T20:59:59Z',
      livestreamEndDate: '2020-01-17T20:59:59Z',
      maxCapacity: 100,
      availableCapacity: null,
      availableFrom: '2019-10-17T20:59:59Z',
      availableTo: '2022-10-17T23:59:59Z',
      soldTicketsCount: 0,
      comment: 'nincs',
      isFreeEntry: false,
      isFree: true,
      ticketFormats: TICKET_FORMATS,
      priceCategories: PRICE_CATEGORY_LIST,
      shortDescription: 'Az Alapítvány-sorozat Isaac Asimov eredetileg trilógiának induló sci-fi műve, amely végül hét regényből álló sorozattá bővült.',
      type: EventVenueType.ONLINE,
      onlineEventType: OnlineEventType.VIDEO,
      customersCountryIsEnabled: true,
    },
  ],
};


export const EVENT_OTHER_DATES: IListResult<IEventViewBase> = {
  resultsLength: 3,
  results: [
    {
      id: '497429fc-bdac-49b7-a4b5-fc6e3224a7f9',
      name: 'Other date 1',
      startDate: '2020-02-28T20:59:59Z',
      endDate: '2020-02-28T20:59:59Z',
      availableCapacity: 13,
      priceCategories: PRICE_CATEGORY_LIST,
      customersCountryIsEnabled: true,
      isFree: false,
    },
    {
      id: '497429fc-bdac-49b7-a4b5-fc6e3224a7f92',
      name: 'Other date 2',
      startDate: '2020-02-24T20:59:59Z',
      endDate: '2020-02-24T20:59:59Z',
      availableCapacity: 0,
      priceCategories: [],
      customersCountryIsEnabled: true,
      isFree: true,
    },
    {
      id: '497429fc-bdac-49b7-a4b5-fc6e3224a7f91',
      name: 'Other date 3',
      startDate: '2020-02-10T20:59:59Z',
      endDate: '2020-02-10T20:59:59Z',
      availableCapacity: 13,
      priceCategories: PRICE_CATEGORY_LIST,
      customersCountryIsEnabled: true,
      isFree: false,
    },
  ],
};

